/* ---------------------------------------------------- */
/* Get Best Class Name                                  */
/* ---------------------------------------------------- */
/*
	It tries to find most important class name among classes.
	If no class, use ID else use the tag name.
*/
window.reGetBestClass = false;

window.stlst_legacy.get_best_class = function( $element ) {
	return getBestClass( $element )
}

/* ---------------------------------------------------- */
/* Blocked IDS                                          */
/* ---------------------------------------------------- */
const getBlockedIds = () => {
	return [
		'widget',
		"recentcomments",
		'fws_([a-zA-Z0-9_-]+)', // 3 party plugin dynamic ID
		'wrapper-[a-zA-Z-0-9]{16,16}' // headway dynamic ID
	]
}

export default function getBestClass( $element ) {
	const mainBody = window.Stylist.iBodyJQ;

	// Default Variables
	let filteredClasses = '',
		DigitalClasses = '',
		numberRex = /\d+/,
		id, passedFilter,returnSelector,goodClassFounded,digitalClassFounded,classes;

	// Cache
	const element = jQuery( $element );

	// Element Classes
	classes = element.attr( "class" );

	// Clean The Element Classes
	if ( classes !== undefined && classes !== null ) {
		classes = jQuery.trim( window.stlst_legacy.class_cleaner( html5_espace_attr( classes ) ) );
	}

	// Cache id and tagname.
	id = element.attr( "id" );
	const tag = element[ 0 ].nodeName.toLowerCase();

	if ( tag == 'body' || tag == 'html' ) {
		return tag;
	}

	/* ---------------------------------------------------- */
	/* GOOD ALLOWED NUMMERIC IDS                            */
	/* ---------------------------------------------------- */
	/* Stylist allow just the following nummeric ids        */
	/* Ex: #section-15 is a allowed nummeric id             */
	/* ---------------------------------------------------- */
	const allowedDigitalIds = [

		// General
		'([a-zA-Z0-9_-]+)?module([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?slide([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?section([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?row([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?layout([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?form([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?wrapper([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?container([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?parallax([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?block([a-zA-Z0-9_-]+)?',

		// 3 party plugin allowed ids
		'layers-widget-([a-zA-Z0-9_-]+)?',
		'builder-module-([a-zA-Z0-9_-]+)?',
		'pg-([a-zA-Z0-9_-]+)?',
		'ptpb_s([a-zA-Z0-9_-]+)?',
		'billing_address_([0-9])([a-zA-Z0-9_-]+)?', // woocommerce
		'el-([a-zA-Z0-9_-]+)',
		'dslc-module-([a-zA-Z0-9_-]+)', // Live Composer
		'module-([0-9]){13,13}-([0-9]){4,4}', // upfront
		'wrapper-([0-9]){13,13}-([0-9]){4,4}' // upfront

	];

	// If Element has ID, Return ID.
	if ( window.stlst_legacy.isDefined( id ) ) {
		// trim
		id = jQuery.trim( html5_espace_attr( id ) );

		// Check if ID has number.
		if ( numberRex.test( id ) ) {
			// allow just some digital ids
			let isIdAllowed = false;

			// This id in allowed list?
			for ( let d = 0; d < allowedDigitalIds.length; d++ ) {
				// yes
				if ( filter_test( allowedDigitalIds[ d ],id ) ) {
					isIdAllowed = true;
					break;
				}
			}

			// else not allow
			if ( isIdAllowed == false ) {
				id = '';
			}
		}

		let blockedIds = getBlockedIds()

		// Blocked id checks
		if ( id != '' ) {
			// Check if a blocked ID
			for ( let f = 0; f < blockedIds.length; f++ ) {
				if ( filter_test( blockedIds[f],id ) ) {
					id = '';
					break;
				}
			}
		}

		// return the available id
		if ( id != '' ) {
			return '#' + id;
		}

	}


	// Class names filtration – level 1:
	// Remove unwated classes.
	// Never use some utility class names....
	if ( classes !== undefined && classes !== null) {
		// Trim
		filteredClasses = jQuery.trim( classes );

		// If length?
		if ( filteredClasses.length > 1 ) {
			// Filter classes in filteredClasses by blockedClasses.
			filteredClasses = filter_classnames_by( window.stlst_legacy.blockedClasses, filteredClasses );
		}

		// Update filtered Classes
		filteredClasses = jQuery.trim( filteredClasses);
	}

	// Class names filtration – level 2:
	// Leave only the best classes.

	let hasFilteredClasses = false;
	let hasFilteredClasses2 = false;
	let filteredClasses2 = false;

	if ( '' !== filteredClasses ) {
		// yes, have.
		hasFilteredClasses = true;

		// Replace significant classes and keep best classes.
		filteredClasses2 = filteredClasses;

		// Replace all non useful classes
		if ( window.stlst_legacy.isDefined( filteredClasses2 ) ) {
			// If has
			if ( filteredClasses2.length > 1 ) {
				filteredClasses2 = filter_classnames_by(
					window.stlst_legacy.unPreferedClasses,
					filteredClasses2
				);
			}

			// trim
			filteredClasses2 = jQuery.trim( filteredClasses2 );
		}
	}

	// If Has Filtered classes2
	if ( jQuery.trim( filteredClasses2 ) != '') {

		// Yes, have.
		hasFilteredClasses2 = true;

	}


	// Transform into array.
	let filteredClassesArray = window.stlst_legacy.get_classes_array( filteredClasses );
	let filteredClasses2Array = window.stlst_legacy.get_classes_array( filteredClasses2 );

	// Foreach classes and exclude nummeric classes
	if ( hasFilteredClasses2 ) {
		let v;
		let isNum = false;

		/* ---------------------------------------------------- */
		/* EXCLUDE BAD NUMMERIC CLASSES                         */
		/* ---------------------------------------------------- */
		/* Never uses the following nummeric classes            */
		/* ---------------------------------------------------- */
		const blockedDigitalClasses = [
			'([a-zA-Z0-9_-]+)?page([_-])item([_-])([0-9]+)',
			'(vc_|vc-)(.*?)(_|-)[a-zA-Z-0-9]{22,22}',
			'themify_builder_content-([0-9]+)',
			'themify_builder_([0-9]+)_row',
			'tb_([0-9]+)_column',
			'et_pb_image_([0-9]+)',
			'([a-zA-Z0-9_-]+)?(post|page|portfolio|product|work|port|form|video)([_-])([0-9]+)',
			'([a-zA-Z0-9_-]+)?(post|page|portfolio|product|work|port|form|video)([_-])(entry|item|id )([_-])([0-9]+)',
			'([0-9])+px',
			'([a-zA-Z0-9_-]+)?wishlist-([0-9])+',
			'wpbs-bookable-([0-9])+',
			'wpbs-day-([0-9])+',
			'([a-zA-Z0-9_-]+)?rand-([0-9])+',
			'([a-zA-Z0-9_-]+)?( ie|ie8|ie9|ie10|ie11)',
			'testimonials-items-([a-zA-Z0-9_-]+)',
			'instance-([0-9]+)'
		];

		for ( let i = 0; i < filteredClasses2Array.length; i++ ) {
			// Value
			v = filteredClasses2Array[ i ];

			// default
			isNum = false;

			if ( numberRex.test( v ) ) {
				isNum = true;
			}

			/* ---------------------------------------------------- */
			/* SKIP SOME NUMMERIC CLASSES AS NORMAL                 */
			/* ---------------------------------------------------- */
			/* process these  nummeric classes as non nummeric      */
			/* ---------------------------------------------------- */
			const filterNumSkipBest = [
				'([a-zA-Z0-9_-]+)?wpcf7([a-zA-Z0-9_-]+)?',
				'([a-zA-Z0-9_-]+)?mc4wp([a-zA-Z0-9_-]+)?'
			];

			// Don't see as nummeric class
			for ( let s = 0; s < filterNumSkipBest.length; s++ ) {
				// skip
				if ( isNum == true && filter_test( filterNumSkipBest[ s ], v ) == true ) {
					isNum = false;
					break;
				}
			}

			// Has number
			if ( isNum) {
				passedFilter = true;

				for ( let m = 0; m < blockedDigitalClasses.length; m++ ) {
					// Not has page-item class | not use vc_'s dynamic class
					if ( filter_test(blockedDigitalClasses[m],v) == true ) {
						passedFilter = false;
						break;
					}
				}

				// Added as nummeric classes
				if ( passedFilter ) {
					DigitalClasses += ' ' + v;
				}
			}
		}
	}

	let filteredDigitalArray = window.stlst_legacy.get_classes_array( DigitalClasses );


	// Clean Up FilteredClasses by digits.
	if ( hasFilteredClasses ) {
		let cleanedFilter = [], cleanedFilter2 = [], i;
		for ( i = 0; i < filteredClassesArray.length; i++ ) {
			if ( ! numberRex.test( filteredClassesArray[ i ] ) ) {
				cleanedFilter.push( filteredClassesArray[ i ] );
			}
		}
		filteredClassesArray = cleanedFilter;
		filteredClasses = filteredClassesArray.join(" ");

		if ( hasFilteredClasses2 ) {
			for ( i = 0; i < filteredClasses2Array.length; i++ ) {
				if ( ! numberRex.test( filteredClasses2Array[ i ] ) ) {
					cleanedFilter2.push( filteredClasses2Array[ i ] );
				}
			}
			filteredClasses2Array = cleanedFilter2;
		}
	}

	/* ---------------------------------------------------- */
	/* PREFERED CLASSES                                     */
	/* ---------------------------------------------------- */
	const preferedClasses = [
		'styled-([a-zA-Z0-9_-]+)?',
		'current-menu-item',
		'active(!singleInspector)',
		'current(!singleInspector)',
		'post',
		'hentry',
		'widget',
		'wp-post-image',
		'(entry|article|post)-title',
		'(entry|article|post)-content',
		'(entry|article|post)-meta',
		'comment-author-admin',
		'([a-zA-Z0-9_-]+)?item',
		'widget-title',
		'widgettitle',
		'next',
		'prev',
		'product',
		'footer',
		'header',
		'sidebar',
		'form-control',
		'footer-top',
		'copyright',
		'menu-item',
		'kc-css-([a-zA-Z0-9_-]+)?',
		'row_inner', // cos row_inner element has a lot bad classes in themify.
		'filterall'
	];

	// search in good class filter
	if ( hasFilteredClasses2 ) {

		goodClassFounded = false;

		// filtered classes
		for ( let i = 0; i < filteredClasses2Array.length; i++ ) {
			// good filters
			for ( let u = 0; u < preferedClasses.length; u++ ) {
				if ( filter_test( preferedClasses[ u ], filteredClasses2Array[ i ] ) ) {
					// if this is "post" and has hentry, prefer hentry
					if ( filteredClasses2Array[ i ] == 'post' && filteredClasses2Array.indexOf( "hentry" ) != -1 ) {
						break;
					}

					goodClassFounded = true;
					returnSelector = "." + filteredClasses2Array[ i ];
					break;
				}
			}

			// stop if founded
			if ( goodClassFounded ) {
				break;
			}
		}
	}

	// Try filtered Classes V1 if not founded in v2
	if ( goodClassFounded == false && hasFilteredClasses == true ) {
		// filtered classes
		for ( let i = 0; i < filteredClassesArray.length; i++ ) {
			// good filters
			for ( let u = 0; u < preferedClasses.length; u++ ) {
				if ( filter_test( preferedClasses[ u ],filteredClassesArray[ i ] ) ) {
					goodClassFounded = true;
					returnSelector = "." + filteredClassesArray[ i ];
					break;
				}
			}

			// stop if founded
			if ( goodClassFounded ) {
				break;
			}
		}
	}

	// Some nummeric classes are important.
	if ( DigitalClasses != '' ) {
		/* ---------------------------------------------------- */
		/* GOOD ALLOWED NUMMERIC CLASSES                        */
		/* ---------------------------------------------------- */
		/* Prefer one digital class in 2 or more.               */
		/* ---------------------------------------------------- */
		const preferedDigitalClasses = [

			// General
			'wp-image-[0-9]+',

			// Basic
			'([a-zA-Z0-9_-]+)?section([a-zA-Z0-9_-]+)?',
			'([a-zA-Z0-9_-]+)?slide([a-zA-Z0-9_-]+)?',
			'([a-zA-Z0-9_-]+)?button([a-zA-Z0-9_-]+)?',
			'([a-zA-Z0-9_-]+)?image([a-zA-Z0-9_-]+)?',
			'([a-zA-Z0-9_-]+)?row([a-zA-Z0-9_-]+)?',

			// Visual composer
			'vc_custom_([a-zA-Z0-9_-]+)?',

			// Beaver builder
			'fl-node([a-zA-Z0-9_-]+)?',
			'fl-row([a-zA-Z0-9_-]+)?',

			// Themify
			'module_row_([0-9]+)',
			'module_column_([0-9]+)',

			// Divi
			'et_pb_(section|row)_[0-9]+',

			// king composer
			'kc-css-([0-9]+)',

			// forge builder
			'forge-col[0-9]+',

			// enfold
			'(avia|av)-builder-el-([0-9]+)',

			// flatsome
			'footer-([0-9]+)'

		];

		digitalClassFounded = false;

		for ( let p = 0; p < filteredDigitalArray.length; p++ ){

			for ( let e = 0; e < preferedDigitalClasses.length; e++ ){

				// is one good nummeric? great
				if ( filter_test(preferedDigitalClasses[e],filteredDigitalArray[p]) == true ){
					digitalClassFounded = true;
					returnSelector = "." + filteredDigitalArray[p];
					break;
				}

			}

			if (digitalClassFounded ){
				break;
			}

		}

	}


	// use input type for selector
	if ( tag == "input" && window.reGetBestClass == false ){

		var type = element.attr("type");

		// Single Inspector
		if ( mainBody.hasClass("stlst-sharp-selector-mode-active") ){

			window.reGetBestClass = true;
			var className = getBestClass($element);

			returnSelector = 'input[type=' + type + ']'+className;

			window.reGetBestClass = false;

		// Default Inspector
		}else{
			returnSelector = 'input[type=' + type + ']';
		}


	}


	// Prefered Tag
	var preferedTag = false;

	// Try find prefered tags
	for ( let n = 0; n < window.stlst_legacy.simpleLikedTags.length; n++ ){

		if ( window.stlst_legacy.simpleLikedTags[n] == tag){
			preferedTag = tag;
			break;
		}

	}


	var lastLuckNummeric = false;

	// if not have any good selector, try nummeric class which pass neverUseNum filter
	if (DigitalClasses != ''){
		lastLuckNummeric = window.stlst_legacy.ai_class( filteredDigitalArray);
	}


	// Matchless Classes for single Inspector
	var matchlessClass = false;

	if ( mainBody.hasClass("stlst-sharp-selector-mode-active") ){

		// Filtered 2 classes: AI
		matchlessClass = matchless2( window.stlst_legacy.ai_class( filteredClasses2Array,true,false ));

		// Filtered 2 classes: NO AI
		if (matchlessClass == false ){
			matchlessClass = matchless2( filteredClasses2Array);
		}


		// filtered 1 classes: AI
		if (matchlessClass == false ){
			matchlessClass = matchless2( window.stlst_legacy.ai_class( filteredClassesArray,true,false ));
		}

		// filtered 1 classes: NO AI
		if (matchlessClass == false ){
			matchlessClass = matchless2( filteredClassesArray);
		}

	}


	// prefered Classes
	var classPrefered = false;

	// Filtered 2 classes: AI
	var classPrefered = window.stlst_legacy.ai_class( filteredClasses2Array,false,false );

	// filtered 1 classes: AI
	if (classPrefered == false ){
		classPrefered = window.stlst_legacy.ai_class( filteredClassesArray,false,false );
	}

	// Recommended selector
	if (window.stlst_legacy.isDefined(returnSelector)){ // Good Classes

		return returnSelector;

	// Cool matchless class for single Inspector
	}else if (matchlessClass != false ){

		return matchlessClass;

	// Try to use prefered class
	}else if (classPrefered != false ){

		return classPrefered;

	// use prefered tags
	}else if (preferedTag != false ){

		return preferedTag;

	// use a nummeric class
	}else if (lastLuckNummeric != false ){

		return lastLuckNummeric;

	// Use any tag if not id
	}else if (tag != 'div'){

		return tag;

	// Use any class if not have alternative.
	}else if ( filteredClasses != '' && filteredClasses != undefined && filteredClasses != null){

		// Get AI class.
		var aiClass = window.stlst_legacy.ai_class( filteredClassesArray);

		// this func will use any class if not have an alternative
		// but blocked digital classes are is dangerous, because these classes
		// is dynamic, changes on page re-load. Use div tag but
		// never use blocked digital class.
		var passedBlockedDigital = true;

		// Loops
		for ( let m = 0; m < blockedDigitalClasses.length; m++ ){

			// Not has page-item class | not use vc_'s dynamic class
			if ( filter_test(blockedDigitalClasses[m],aiClass.replace(/^(\.|#)/g, '')) == true ){

				passedBlockedDigital = false;
				break;

			}

		}

		// return AI class if pass blocked digital classes
		if (passedBlockedDigital){
			return aiClass;
		}
			return tag; // Return tag even "div".


	} else {

		return tag;

	}

}

/* ---------------------------------------------------- */
/* Espacing some new ID and Class chars                 */
/* ---------------------------------------------------- */
function html5_espace_attr( value ) {
	if ( value === null | value === undefined || typeof value == typeof undefined || value == false || value == true ) {
		return value;
	}

	return delete_bad_terms( value ).replace( /(@|\.|\/|!|\*|#|\+)/g, "\\$1" );
}

/* ---------------------------------------------------- */
/* Deleting non-acceptable classes & ids                */
/* ---------------------------------------------------- */
function delete_bad_terms( classes ) {
	// list
	let classesArray = [];

	// Clean
	classes = jQuery.trim( classes );

	// Clean multispaces
	classes = classes.replace( /\s\s+/g, ' ' );

	// Check if still there have another class
	if ( classes.indexOf( " " ) != -1 ) {
		let classessplit = classes.split( " " );

		// Split with space
		let v;
		for ( let i = 0; i < classessplit.length; i++ ) {
			// Clean
			v = jQuery.trim( classessplit[ i ] );

			// Push
			if ( /([\u2018\u2019\u201A\u201B\u2032\u2035\u201C\u201D]|\{|\}|\:|\<|\>|\(|\)|\[|\]|\~|\"|\'|\?|\\)/g.test( v ) == false ) {
				classesArray.push( v );
			}
		}
	}else {
		// Push if single.
		if ( /([\u2018\u2019\u201A\u201B\u2032\u2035\u201C\u201D]|\{|\}|\:|\<|\>|\(|\)|\[|\]|\~|\"|\'|\?|\\)/g.test( classes ) == false ) {
			classesArray.push( classes );
		}
	}

	return classesArray.join( " " );
}

/* ---------------------------------------------------- */
/* Filtering classes by filter                          */
/* ---------------------------------------------------- */
function filter_classnames_by( filter, classes ) {
	let a;

	for ( let i = 0; i < filter.length; i++ ) {
		// Regex
		a = new RegExp( "(\\s|^)" + filter[ i ] + "(\\s|$)", "gi" );

		// Replace
		classes = classes.replace( a, ' ' );
	}

	return classes.trim();
}

/* ---------------------------------------------------- */
/* Filtering test                                       */
/* ---------------------------------------------------- */
function filter_test( filter,classN){

	// Is Single Inspector
	// if filter has 'just single inspector' regEx
	if (/\(singleInspector\)/g.test( filter)){
		return false; // because is not active
	}else{
		filter = filter.replace(/\(singleInspector\)/g,'');
	}

	// Regex
	var r = new RegExp("(\\s|^)" + filter + "(\\s|$)","gi");

	// has
	if (r.test(classN)){
		return true;
	} // not have
		return false;


}



// WEBPACK FOOTER //
// ./dev/stylist_parent/functions/get-best-class.js